import React from 'react';
import CustomerListItem from './CustomerListItem';

const CustomerList = ({ data }) => {

    if (!data.length) {
        return (<p>Nenhuma entrega encontrada para este documento.</p>)
    }

    const items = data.map(item => <CustomerListItem key={item.customer_id} data={item} />);

    return (
        <table className="table customers-table">
            <thead>
                <tr>
                    <th>CNPJ/CPF</th>
                    <th>Nome</th>
                    <th>Endereço</th>
                    <th>Prev. de Entrega</th>
                    <th>Entregas</th>
                    <th>Visita</th>
                    <th>Devoluções</th>
                    <th>Status</th>
                </tr>
            </thead>

            {items}
        </table>
    );
}

CustomerList.defaultProps = {
    data: []
}

export default CustomerList;



// WEBPACK FOOTER //
// ./src/components/Delivery/CustomerList.js